import { useMemo } from 'react';
import SectorKpiOverview from '../components/overview/SectorKpiOverview';
import { useAppSelector } from '../../../core/rootHooks';
import { IKpiVessel } from '../kpiTypes';
import { selectSelectionData } from '../../search/searchSelectors';
import DynamicTab from '../../../shared/components/tabs/DynamicTab';

export interface ISummaryKpiProps {
	selectedVessels: IKpiVessel[] | [];
}

const SummaryKpi: React.FC<ISummaryKpiProps> = ({ ...props }) => {
	// const summaryKeyMetrics = useAppSelector(summaryKeyMetricsInfoSelector);
	const { selectionName } = useAppSelector(selectSelectionData);

	const sectorData = useMemo(() => {
		const dataList = props.selectedVessels || [];
		const groupedData = dataList.reduce(
			(acc, item: IKpiVessel) => {
				const { sectorName, sectorId, imoNumber } = item;
				if (!acc[sectorId]) {
					acc[sectorId] = {
						sectorName,
						sectorId,
						imoList: [],
					};
				}
				acc[sectorId].imoList.push(imoNumber);
				return acc;
			},
			{} as Record<number, { sectorName: string; sectorId: number; imoList: number[] }>,
		);

		return Object.values(groupedData);
	}, [props.selectedVessels]);

	const sectorsTabs = () => {
		return sectorData.map((item) => {
			return {
				id: item.sectorId.toString(),
				label: item.sectorName,
				content: <SectorKpiOverview title={selectionName} sectorId={item.sectorId} imoList={item.imoList} />,
			};
		});
	};

	return <DynamicTab items={sectorsTabs()} tabColor="msi-darkgrey-color" props={{ isVertical: true }} giveSpace />;
};

export default SummaryKpi;
